import { Component, Input } from "@angular/core";
import { IKrUpdate, ReflectionQuestionType } from "../../models/reflections.models";
import { ReflectionFormQuestion } from "../../models/reflection-details.models";

@Component({
  selector: "reflection-details",
  templateUrl: "./reflection-details.component.html",
  styleUrls: ["./reflection-details.component.less"],
})
export class ReflectionDetailsComponent {
  @Input()
  public title = "";

  @Input()
  public subtitle = "";

  @Input()
  public questions: ReflectionFormQuestion<ReflectionQuestionType>[] = [];

  @Input()
  public krUpdates: IKrUpdate[] = [];

  @Input()
  public readOnly = false;

  get reflectionQuestionType(): typeof ReflectionQuestionType {
    return ReflectionQuestionType;
  }
}
